<header>
  <button class="close-button" mat-dialog-close mat-icon-button>
    <mat-icon fontIcon="close"></mat-icon>
  </button>
  <h3>{{ 'dialog.co2_dangling_title' | translate }}</h3>
</header>

<mat-dialog-content>
  <p>{{ 'dialog.co2_dangling_content' | translate }}</p>
  <app-loading-spinner *ngIf="(isLoading$ | async) && ((facility$ | async) === undefined)"></app-loading-spinner>
  <ul class="facility-info" *ngIf="(facility$ | async )as facility">
    <li>{{ 'dialog.co2_dangling_content_location_name' | translate }}: {{facility.facility_name}}</li>
    <li>{{ 'dialog.co2_dangling_content_location' | translate }}: {{facility.facility_street}} {{facility.facility_street_number}}, {{facility.facility_zip_code}} {{facility.facility_city}}</li>
  </ul>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="spacer"></div>
  <button (click)="onSave()"
          color="accent"
          mat-flat-button
          type="submit">
    {{ 'dialog.actions.save_co2_dangling' | translate }}
  </button>
</mat-dialog-actions>
